import { Component, Input, Output, EventEmitter } from '@angular/core';

import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { Button } from 'primeng/button';
import { Tag } from 'primeng/tag';
import { Tooltip } from 'primeng/tooltip';
import { ProgressSpinner } from 'primeng/progressspinner';
import { TranslateModule } from '@ngx-translate/core';

export interface CheckInEntry {
  id: string;
  reservationNumber: string;
  guestName: string;
  roomType: string;
  roomNumber: string;
  checkInDate: string;
  checkInTime: string;
  checkOutDate: string;
  status: 'pending' | 'completed' | 'canceled';
  documentId?: string;
  phone: string;
  email: string;
  specialRequests?: string;
}

@Component({
  selector: 'lib-check-in-table',
  standalone: true,
  imports: [TableModule, Button, Tag, Tooltip, ProgressSpinner, TranslateModule],
  templateUrl: './check-in-table.component.html',
  styleUrls: ['./check-in-table.component.scss'],
})
export class CheckInTableComponent {
  @Input() checkIns: CheckInEntry[] = [];
  @Input() loading = false;
  @Input() totalRecords = 0;
  @Input() first = 0;
  @Input() rows = 20;

  @Output() processCheckIn = new EventEmitter<CheckInEntry>();
  @Output() cancelCheckIn = new EventEmitter<CheckInEntry>();
  @Output() pageChange = new EventEmitter<TableLazyLoadEvent>();

  getStatusSeverity(status: string): 'success' | 'info' | 'warn' | 'danger' {
    const severityMap: Record<string, 'success' | 'info' | 'warn' | 'danger'> = {
      completed: 'success',
      pending: 'warn',
      cancelled: 'danger',
    };
    return severityMap[status] || 'info';
  }

  onProcessCheckIn(entry: CheckInEntry): void {
    this.processCheckIn.emit(entry);
  }

  onCancelCheckIn(entry: CheckInEntry): void {
    this.cancelCheckIn.emit(entry);
  }

  onPageChange(event: TableLazyLoadEvent): void {
    this.pageChange.emit(event);
  }

  truncateText(text: string | undefined, maxLength: number): string {
    if (!text) return '';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  }
}
